import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {TrafficSource} from '../../models/traffic-source';

@Injectable({
  providedIn: 'root'
})
export class TrafficSourceService extends AbstractModelService<TrafficSource> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/traffic-source', TrafficSource);
  }
}
